// extracted by mini-css-extract-plugin
export default {"footerButton":"_1KV8tKraZkCkuoZSTi5wzD"};